import { Box, styled } from "@mui/material";

export const AsyncPaginateFormFieldStyled = styled(Box)`
  .field-label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 6px;
  }
`;
